import React, { useState, useEffect } from "react";
import {
  Container,
  Navbar,
  Modal,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaBars,
  FaClock,
  FaSignOutAlt,
  FaPhoneAlt,
  FaExpandAlt,
} from "react-icons/fa";
// Context
import { useAuth } from "../../auth/AuthContext";

// Logos
import logo from "../images/logo_utility_web.png";

function BasicExample() {
  const { user, logout } = useAuth();

  // Stato per il Countdown in tempo reale
  const [shiftStatus, setShiftStatus] = useState({
    label: "",
    timeRemaining: "00:00:00",
  });

  // Stato per il modale "Rubrica completa"
  const [showRubricaModal, setShowRubricaModal] = useState(false);

  // Struttura Rubrica: Reparto -> 2/3 Numeri (Nome a sinistra, Numero a destra)
  const [rubricaAziendale] = useState([
    {
      reparto: "Direzione & Sede",
      contatti: [
        { id: 1, nome: "Alessandro", numero: "207" },
        { id: 2, nome: "Rita", numero: "206" },
        { id: 3, nome: "Direzione", numero: "300" },
      ],
    },
    {
      reparto: "Reaparto Vendite",
      contatti: [
        { id: 4, nome: "Emiliano", numero: "203" },
        { id: 5, nome: "Bruno", numero: "204" },
        { id: 6, nome: "Roberta", numero: "218" },
        { id: 6, nome: "Rosy", numero: "211" },
        { id: 6, nome: "Francesca", numero: "" },
      ],
    },
    {
      reparto: "Reparto Acquisti",
      contatti: [
        { id: 7, nome: "Denise", numero: "202" },
        { id: 8, nome: "Noemi", numero: "213" },
        { id: 8, nome: "Ilenia", numero: "219" },
      ],
    },
    {
      reparto: "Reparto IT",
      contatti: [
        { id: 9, nome: "Federico", numero: "201" },
        { id: 10, nome: "Dario", numero: "212" },
        { id: 10, nome: "Sabri", numero: "223" },
      ],
    },
    {
      reparto: "Reparto Marketing",
      contatti: [{ id: 9, nome: "Leandro", numero: "222" }],
    },
    {
      reparto: "Amotive",
      contatti: [
        { id: 9, nome: "Emanuele", numero: "205" },
        { id: 9, nome: "Daniela", numero: "214" },
        { id: 9, nome: "Irene", numero: "222" },
        { id: 9, nome: "Simone Brenna", numero: "231" },
      ],
    },
    {
      reparto: "Sud Ricambi",
      contatti: [
        { id: 9, nome: "Preventivi 1", numero: "301" },
        { id: 9, nome: "Preventivi 2", numero: "302" },
        { id: 9, nome: "Marco", numero: "304" },
        { id: 9, nome: "Carmen", numero: "311" },
        { id: 9, nome: "Raffaele", numero: "309" },
      ],
    },
    {
      reparto: "Sud Ricambi",
      contatti: [
        { id: 9, nome: "Banco 1", numero: "306" },
        { id: 9, nome: "Banco 2", numero: "307" },
        { id: 9, nome: "Officina", numero: "310" },
        { id: 9, nome: "Rapido", numero: "308" },
      ],
    },
    {
      reparto: "Sogedim",
      contatti: [
        { id: 9, nome: "Sogedim",   numero: "02-297207301    (260)" },
        { id: 9, nome: "Marco",     numero: "02-40704483     (261)" },
        { id: 9, nome: "Francesco", numero: "02-40704512     (262)" },
        { id: 9, nome: "Dejan",     numero: "02-40704296     (263)" },
      ],
    },
  ]);

  // Calcolo iniziale per l'avatar
  const usernameDisplay = user || "Utente";
  const userInitial = usernameDisplay.charAt(0).toUpperCase();

  /* =========================================================
      CALCOLO TEMPO REALE CHECK-IN / CHECK-OUT (IN-LINE)
  ========================================================= */
  useEffect(() => {
    const attendance = {
      checkInMattina: "08:30:00",
      checkOutMattina: "13:30:00",
      checkInPomeriggio: "14:00:00",
      checkOutPomeriggio: null,
    };

    const timeToSeconds = (time) => {
      if (!time) return null;
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    };

    const secondsToTime = (totalSeconds) => {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
        String(seconds).padStart(2, "0"),
      ].join(":");
    };

    const calculateWorkedSeconds = () => {
      let totalSeconds = 0;

      const checkInMattina = timeToSeconds(attendance.checkInMattina);
      const checkOutMattina = timeToSeconds(attendance.checkOutMattina);

      if (checkInMattina !== null && checkOutMattina !== null) {
        totalSeconds += Math.max(0, checkOutMattina - checkInMattina);
      }

      const checkInPomeriggio = timeToSeconds(attendance.checkInPomeriggio);
      const checkOutPomeriggio = timeToSeconds(attendance.checkOutPomeriggio);

      if (checkInPomeriggio !== null && checkOutPomeriggio !== null) {
        totalSeconds += Math.max(0, checkOutPomeriggio - checkInPomeriggio);
      } else if (checkInPomeriggio !== null && checkOutPomeriggio === null) {
        const now = new Date();
        const currentSeconds =
          now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        totalSeconds += Math.max(0, currentSeconds - checkInPomeriggio);
      }

      if (checkInMattina !== null && checkOutMattina === null) {
        const now = new Date();
        const currentSeconds =
          now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        totalSeconds = Math.max(0, currentSeconds - checkInMattina);
      }

      return totalSeconds;
    };

    const updateWorkedTime = () => {
      const workedSeconds = calculateWorkedSeconds();
      setShiftStatus({
        label: "Ore lavorate",
        timeRemaining: secondsToTime(workedSeconds),
      });
    };

    updateWorkedTime();
    const interval = setInterval(updateWorkedTime, 1000);
    return () => clearInterval(interval);
  }, []);

  // Apre il modale con la rubrica completa e chiude il dropdown
  const handleOpenRubricaModal = () => {
    setShowRubricaModal(true);
    document.body.click(); // chiude il dropdown aperto (react-bootstrap si chiude su click fuori)
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="ombra-dark m-3 mb-0 mt-2 px-4 py-2 border-0 custom-utility-nav"
        style={{
          borderRadius: "50px",
          minHeight: "60px",
        }}
      >
        <Container fluid className="p-0">
          <Navbar.Brand as={Link} to="/home" className="d-flex align-items-center">
            <img src={logo} alt="Logo Utility Web" style={{ height: "45px", width: "auto" }} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-responsive" className="border-0 shadow-none">
            <FaBars style={{ color: "#ebb51b" }} />
          </Navbar.Toggle>

          <Navbar.Collapse id="navbar-responsive">

            
            <div className="d-flex flex-column flex-lg-row align-items-lg-center w-100 mt-3 mt-lg-0">
              {/* BLOCCO UTENTE E CHECK-IN/OUT A DESTRA */}
              <div className="d-flex align-items-center gap-3 ms-auto mt-3 mt-lg-0">
                {/* 1. Profilo Utente */}
                

               {/* <div className="v-separator-utility d-none d-lg-block"></div>

                 2. Badge Orari Turni IN-LINE 
                <div
                  className="d-flex align-items-center gap-2 bg-dark-pill px-3 py-1 rounded-pill"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <FaClock style={{ color: "#ebb51b", fontSize: "0.85rem", flexShrink: 0 }} />
                  <span className="style-orari-inline">
                    <strong>M:</strong> 08:30-13:30
                    <span className="mx-1 text-muted">|</span>
                    <strong>P:</strong> 14:00-17:00
                    <span className="badge bg-gold-subtle text-warning ms-2 font-monospace">
                      {shiftStatus.label}: {shiftStatus.timeRemaining}
                    </span>
                  </span>
                </div>*/}

                

                {/* 3. DROPDOWN RUBRICA con tasto di espansione */}
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="link"
                    id="dropdown-rubrica"
                    className="btn-rubrica-toggle p-0 border-0 text-decoration-none d-flex align-items-center gap-1 hover-gold"
                  >
                    <FaPhoneAlt style={{ fontSize: "0.85rem", color: "#ebb51b" }} />
                    <span className="text-white fw-semibold" style={{ fontSize: "0.75rem" }}>
                      Rubrica Azienda
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="rubrica-menu-dark shadow-lg p-3 mt-2">
                    {/* Header con tasto espandi */}
                    <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom border-secondary">
                      <span className="text-white-50 fw-semibold" style={{ fontSize: "0.72rem", letterSpacing: "0.5px" }}>
                        ANTEPRIMA
                      </span>
                      <button
                        onClick={handleOpenRubricaModal}
                        className="btn-espandi-rubrica"
                        title="Apri rubrica completa"
                      >
                        <FaExpandAlt size={12} />
                        <span>Espandi</span>
                      </button>
                    </div>

                    <div className="scroll-hidden" style={{ maxHeight: "320px", overflowY: "auto" }}>
                      {rubricaAziendale.map((sezione, index) => (
                        <div key={index} className="mb-3 last-mb-0">
                          <div className="reparto-header text-warning fw-bold text-uppercase border-bottom border-secondary pb-1 mb-2">
                            {sezione.reparto}
                          </div>
                          {sezione.contatti.map((contatto) => (
                            <div
                              key={contatto.id}
                              className="d-flex justify-content-between align-items-center py-1 px-1 user-select-none"
                            >
                              <span className="contatto-nome text-white-50">{contatto.nome}</span>
                              <span className="contatto-numero text-white font-monospace fw-semibold ms-3">
                                {contatto.numero}
                              </span>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>

                <div className="v-separator-utility d-none d-lg-block"></div>

                <div className="d-flex align-items-center gap-2">
                  <div className="avatar-circle">{userInitial}</div>
                  <span
                    className="text-white fw-bold truncate"
                    style={{ fontSize: "0.85rem", maxWidth: "120px" }}
                  >
                    {usernameDisplay}
                  </span>
                </div>

                <div className="v-separator-utility d-none d-lg-block"></div>

                {/* 4. Pulsante Logout */}
                {logout && (
                  <button
                    onClick={logout}
                    className="btn btn-sm btn-link text-white text-decoration-none p-1 ms-1 hover-gold"
                    title="Esci"
                  >
                    <FaSignOutAlt style={{ fontSize: "0.9rem" }} />
                  </button>
                )}
              </div>
            </div>
          </Navbar.Collapse>
        </Container>

        <style>{`
          /* Liquid Glass: stesso ingombro originale della navbar */
          .custom-utility-nav {
            position: relative;
            z-index: 12000;
            overflow: visible;

            background:
              linear-gradient(
                135deg,
                rgba(255,255,255,0.115) 0%,
                rgba(255,255,255,0.065) 48%,
                rgba(255,255,255,0.035) 100%
              ) !important;

            border: 1px solid rgba(255,255,255,0.16) !important;

            box-shadow:
              0 16px 46px rgba(0,0,0,0.26),
              inset 0 1px 0 rgba(255,255,255,0.20),
              inset 0 -1px 0 rgba(0,0,0,0.08) !important;

            backdrop-filter: blur(26px) saturate(150%);
            -webkit-backdrop-filter: blur(26px) saturate(150%);
          }

          .custom-utility-nav::before {
            content: "";
            position: absolute;
            top: 0;
            left: 5%;
            width: 54%;
            height: 1px;
            pointer-events: none;
            border-radius: 999px;
            background: linear-gradient(
              90deg,
              rgba(255,255,255,0.48),
              rgba(255,255,255,0.12),
              transparent
            );
          }

          .custom-utility-nav > .container-fluid {
            position: relative;
            z-index: 1;
          }

          .nav-link-custom {
            color: #f1f1f1 !important;
            font-size: 0.75rem;
            font-weight: 600;
            display: flex;
            align-items: center;
            transition: all 0.2s ease;
          }

          .nav-link-custom:hover, .hover-gold:hover {
            color: #ebb51b !important;
            transform: translateY(-1px);
          }

          .avatar-circle {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-color: #ebb51b;
            color: #212529;
            font-weight: 700;
            font-size: 0.85rem;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px rgba(0,0,0,0.2);
          }

          .bg-dark-pill {
            background: rgba(0, 0, 0, 0.35);
            border: 1px solid rgba(255, 255, 255, 0.08);
          }

          .style-orari-inline {
            font-size: 0.75rem;
            color: #e0e0e0;
            display: flex;
            align-items: center;
          }

          .style-orari-inline strong { color: #ebb51b; }

          .bg-gold-subtle {
            background-color: rgba(235, 181, 27, 0.15) !important;
            border: 1px solid rgba(235, 181, 27, 0.3);
            font-size: 0.72rem;
            padding: 3px 6px;
          }

          .v-separator-utility {
            width: 1px;
            height: 22px;
            background: rgba(255, 255, 255, 0.18);
            margin: 0 4px;
          }

          .btn-rubrica-toggle::after {
            display: inline-block;
            margin-left: 0.3em;
            vertical-align: 0.2em;
            content: "";
            border-top: 0.3em solid #ebb51b;
            border-right: 0.3em solid transparent;
            border-bottom: 0;
            border-left: 0.3em solid transparent;
          }

          /* Dropdown Rubrica: Liquid Glass, ma senza modificare la navbar */
          .custom-utility-nav .dropdown {
            position: relative;
            z-index: 12020;
          }

          .rubrica-menu-dark {
            z-index: 12030 !important;
            min-width: 320px;
            overflow: hidden;

            background:
              linear-gradient(
                145deg,
                rgba(48,50,55,0.84),
                rgba(24,26,30,0.78)
              ) !important;

            border: 1px solid rgba(255,255,255,0.15) !important;
            border-radius: 18px;

            box-shadow:
              0 28px 70px rgba(0,0,0,0.46),
              inset 0 1px 0 rgba(255,255,255,0.16);

            backdrop-filter: blur(30px) saturate(150%);
            -webkit-backdrop-filter: blur(30px) saturate(150%);
          }

          /* Tasto "Espandi" nel dropdown */
          .btn-espandi-rubrica {
            display: flex;
            align-items: center;
            gap: 5px;
            background: transparent;
            border: 1px solid rgba(235, 181, 27, 0.4);
            color: #ebb51b;
            border-radius: 20px;
            font-size: 0.68rem;
            font-weight: 600;
            padding: 3px 10px;
            transition: all 0.15s ease;
          }
          .btn-espandi-rubrica:hover {
            background-color: #ebb51b;
            color: #212224;
          }

          .reparto-header { font-size: 0.72rem; letter-spacing: 0.5px; }
          .contatto-nome { font-size: 0.78rem; }
          .contatto-numero { font-size: 0.78rem; }
          .last-mb-0:last-child { margin-bottom: 0 !important; }

          /* Scrollbar invisibile ma scroll funzionante, ovunque venga applicata */
          .scroll-hidden {
            scrollbar-width: none;        /* Firefox */
            -ms-overflow-style: none;     /* IE / Edge legacy */
          }
          .scroll-hidden::-webkit-scrollbar {
            display: none;                /* Chrome, Safari, Edge Chromium */
          }

          .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
          .ombra-dark { box-shadow: 0 4px 20px rgba(0,0,0,0.35); }
          #navbar-responsive { background-color: transparent !important; flex-direction: column; align-items: flex-start; }

          /* Modale Rubrica completa: Liquid Glass */
          .rubrica-modal-dark {
            z-index: 13000 !important;
          }

          .rubrica-modal-dark .modal-dialog {
            position: relative;
            z-index: 13001;
          }

          .rubrica-modal-dark .modal-content {
            position: relative;
            overflow: hidden;

            background:
              linear-gradient(
                145deg,
                rgba(50,52,58,0.82),
                rgba(23,25,29,0.76)
              ) !important;

            border: 1px solid rgba(255,255,255,0.16) !important;
            border-radius: 24px;

            box-shadow:
              0 38px 110px rgba(0,0,0,0.52),
              inset 0 1px 0 rgba(255,255,255,0.18),
              inset 0 -1px 0 rgba(0,0,0,0.10);

            backdrop-filter: blur(34px) saturate(150%);
            -webkit-backdrop-filter: blur(34px) saturate(150%);
          }

          .rubrica-modal-dark .modal-content::before {
            content: "";
            position: absolute;
            top: 0;
            left: 7%;
            width: 55%;
            height: 1px;
            pointer-events: none;
            background: linear-gradient(
              90deg,
              rgba(255,255,255,0.50),
              rgba(255,255,255,0.10),
              transparent
            );
          }

          .rubrica-modal-dark .modal-header {
            position: relative;
            z-index: 2;
            border-bottom: 1px solid rgba(255,255,255,0.09);
            background: rgba(255,255,255,0.018);
          }

          .rubrica-modal-dark .modal-body {
            position: relative;
            z-index: 2;
          }

          .rubrica-reparto-card {
            background:
              linear-gradient(
                145deg,
                rgba(255,255,255,0.060),
                rgba(255,255,255,0.025)
              );
            border: 1px solid rgba(255,255,255,0.09);
            border-radius: 14px;
            padding: 14px 16px;
            height: 100%;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.06);
          }

          /* backdrop sopra calendario/sidebar fisse */
          .modal-backdrop.show {
            z-index: 12990 !important;
            background-color: rgba(8,9,12,0.70);
            opacity: 1 !important;
            backdrop-filter: blur(14px);
            -webkit-backdrop-filter: blur(14px);
          }
        `}</style>
      </Navbar>

      {/* ── MODALE: Rubrica Aziendale completa ────────────────── */}
      <Modal
        show={showRubricaModal}
        onHide={() => setShowRubricaModal(false)}
        centered
        size="lg"
        className="rubrica-modal-dark  p-5"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title className="text-white d-flex align-items-center gap-2" style={{ fontSize: "1.05rem" }}>
            <FaPhoneAlt style={{ color: "#ebb51b", fontSize: "0.9rem" }} />
            Rubrica Aziendale
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="scroll-hidden" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Row className="g-3">
            {rubricaAziendale.map((sezione, index) => (
              <Col md={4} sm={6} xs={12} key={index}>
                <div className="rubrica-reparto-card">
                  <div className="reparto-header text-warning fw-bold text-uppercase border-bottom border-secondary pb-2 mb-2">
                    {sezione.reparto}
                  </div>
                  {sezione.contatti.map((contatto) => (
                    <div
                      key={contatto.id}
                      className="d-flex justify-content-between align-items-center py-1 user-select-none"
                    >
                      <span className="contatto-nome text-white-50">{contatto.nome}</span>
                      <span className="contatto-numero text-white font-monospace fw-semibold ms-3">
                        {contatto.numero}
                      </span>
                    </div>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BasicExample;